export class CRMAttribute {
  constructor(public name: string, public freemarker: string, public childAttributes: CRMAttribute[]) {}
}

export enum CRMEntity {
  Contact,
  Lead,
  Account,
  Owner,
  EmailSend
}

export class PersonalizationEntity {
  name: string;
  entity: CRMEntity;
}
